import type { IndexJobDTO, IndexState, MutationClass } from '../../../models'

export class SetJobsMutation implements MutationClass {
  static execute(this: void, state: IndexState, jobs: Array<IndexJobDTO>): void {
    state.jobs = jobs
  }
}
